import axiosInstance from './axios';
import Venue from 'types/models/Venue';
import { parseCommerces } from './commercesService';

export const getVenues = async (): Promise<Venue[] | null> => {
  try {
    const { data } = await axiosInstance({
      method: 'get',
      url: '/commerces/get/current-venues',
    });
    return parseVenues(data);
  } catch (error) {
    console.log(error);
    return null;
  }
};

const parseVenues = (venues: any): Venue[] => {
  return venues.map((venue: any): Venue => {
    return parseVenue(venue);
  });
};

export const getVenuesByFranchiseEditor = async (): Promise<Venue[] | null> => {
  try {
    const { data } = await axiosInstance({
      method: 'POST',
      url: '/venues/get/by-franchise-commerces',
    });
    return parseVenues(data);
  } catch (error) {
    console.log(error);
    return null;
  }
};

const parseVenue = (venue: any): Venue => {
  return {
    id: venue.id,
    name: venue.name,
    code: venue.code,
    enabled: venue.enabled,
    paymentConfigId: venue.payment_config_id,
    billingRange: venue.billing_range,
    countryBillingConfigId: venue.country_billing_config_id,
    createdAt: venue.created_at,
    updatedAt: venue.updated_at,
    localDateTimeIdentifier: venue.local_timezone_identifier,
    images: venue.images,
    editorId: venue.editor_id,
    paymentConfig: {
      id: venue.payment_config.id,
      activePaymentProviderId: venue.payment_config.active_payment_provider_id,
      balanceEnabled: venue.payment_config.balance_enabled === 1,
      cashEnabled: venue.payment_config.cash_enabled === 1,
      firstDataConfigId: venue.payment_config.first_data_config_id,
      mpConfigId: venue.payment_config.mp_config_id,
      priorityOverCommerce: venue.payment_config.priority_over_commerce === 1,
      cloverPointConfigId: venue.payment_config.clover_point_config_id,
    },
    eventName: venue.event_name,
    appColor: venue.app_color ?? undefined,
    commerces: parseCommerces(venue.commerces),
    pickupVerificationMethod: venue.delivery_config?.pick_up_verification_method ?? 0,
  };
};
